var _rect, _rect2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 40,
    rx: 6,
    fill: "#fff",
    stroke: "#333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 64,
    height: 12,
    fill: "#f57200"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "45%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 12,
    fill: "#000"
  }, "\n    DISCOVER\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.7f762856babed6c2f854fe388e0a943a.svg";
export { ForwardRef as ReactComponent };